<template>
  <div class="main">

     <v-flex xs12 class="mb-4 pb-4">
      <!-- <v-toolbar fixed dense class="toolbar"> -->
      <v-toolbar fixed dense color="white">
        <v-btn icon light to="/">
          <v-icon color="grey darken-2">arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title class="grey--text text--darken-4 text-xs-center tklogo">T K</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn icon light><v-icon color="grey darken-2">search</v-icon></v-btn> -->
        <v-btn active-class icon to="/tkbios">
          <v-tooltip color="blue" nudge-left="40px" bottom>
            <!-- <v-icon slot="activator" color="black" dark>fa fa-paw</v-icon> -->
            <v-icon slot="activator" color="black" dark>fas fa-cat</v-icon>
            <span>Back to All TK Cat Bios</span>
          </v-tooltip>
        </v-btn>
        <v-btn active-class icon to="/">
          <v-tooltip color="blue" nudge-left="30px" bottom>
            <v-icon slot="activator" color="black" dark>fa fa-home</v-icon>
            <span>Back to Home</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat round icon :href="facebook" target="_blank">
          <v-tooltip color="blue" nudge-left="30px" bottom>
          <v-icon slot="activator" color="black" medium>fab fa-facebook-square</v-icon>
            <span>Visit Us on Facebook</span>
          </v-tooltip>
        </v-btn>
      </v-toolbar>
    </v-flex>

    <section>
      <!-- <v-parallax :src="require('../img/white_lion_laying_down_1440x960.jpg')" height="500" alt="this is not working"> -->
      <v-parallax :src="require('../img/white_lion_laying_down_1024x683.jpg')" height="500" alt="this is not working">
      <!-- <v-parallax class="paralx" height="600"> -->
        <v-layout
          column
          align-center
          justify-center
          class="black--text"
        >
          <!-- <img src="assets/vuetify.png" alt="Tk Logo Here" height="200"> -->
          <p class="mainlogo">Timmy's Kitty's Contacts</p>
          <!-- <div class="subheading mb-3 text-xs-center">Powered by Vuetify</div> -->
          <!--
          <v-btn
            class="blue lighten-2 mt-5"
            dark
            large
            href=""
          >
            Get Started
          </v-btn>
          -->
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container grid-list-xl>
        <v-layout row wrap justify-center class="my-5">
          <v-flex xs12 sm7>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">Send Us A Message</div>
              </v-card-title>
              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    :counter="50"
                    label="Name"
                    required
                    color="blue"
                    box
                  ></v-text-field>
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                    color="blue"
                    box
                  ></v-text-field>
                  <v-textarea
                    v-model="message"
                    :rules="messageRules"
                    :counter="1024"
                    auto-grow
                    label="Message"
                    rows="1"
                    color="blue"
                    box
                  ></v-textarea>
                  <v-btn :disabled="!valid" @click="submit">submit</v-btn>
                  <v-btn @click="clear">clear</v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 offset-sm1>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">Contact us</div>
              </v-card-title>
              <v-card-text>
                Timmy's Kitty's is still in development. However, you can still contact us via email or visit us on Facebook.
              </v-card-text>
              <v-list class="transparent">

                <!--
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2">phone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>555-555-5300</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2">place</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>New Zealand</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                -->

                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2">email</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <a style="text-decoration: none; list-style-type: none; color: blue;" class="mail-to" href="mailto:tkwebdev23@gmail.com">tkwebdev23@gmail.com</a>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2">fab fa-facebook-square</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-btn flat round href="https://www.facebook.com/timmyskittys1" target="_blank">
                      <v-list-tile-title>TK FaceBook</v-list-tile-title>
                    </v-btn>
                  </v-list-tile-content>
                </v-list-tile>

              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <v-container>
      <v-layout class="footer">
        <footer-view></footer-view>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
/* eslint-disable */
import TkHeaderView from "./TkHeaderView";
import FooterView from "./FooterView";

export default {
  components: {
    TkHeaderView,
    FooterView
  },
  data: () => ({
    facebook: "https://www.facebook.com/timmyskittys1",
    valid: false,
    name: "",
    message: "",
    messageRules: [
      v =>
        (v && v.length <= 1024) ||
        "The message must be less than 1024 characters"
    ],
    nameRules: [
      v => !!v || "Name is required",
      v => (v && v.length <= 50) || "Name must be less than 50 characters"
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ]
  }),
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        // Native form submission is not yet supported
        axios.post("/api/submit", {
          name: this.name,
          email: this.email,
          message: this.message
        });
      }
    },
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped>
.main {
  /* background-image: url("../img/white_wrinkled_silk_blue_1440x1190.jpg"); */
  background-color: #f8f8ff;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
.paralx {
  /* background-image: url("../img/mountain_range_with_clouds_1024x768.jpg"); */
  background-size: cover;
  background-repeat: no-repeat;
}
.mailto {
  text-decoration: none;
  list-style-type: none;
}
.mainlogo {
  font-size: 8rem;
  margin-top: 50px;
  color: #0a4cff;
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
}
.tklogo {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 2rem;
  font-weight: bold;
}
.footer {
}
@media screen and (max-width: 990px) {
  .mainlogo {
    font-size: 5rem;
  }
}
/* @media screen and (max-width: 599px) { */
@media screen and (max-width: 659px) {
  .mainlogo {
    font-size: 3rem;
  }
}
@media screen and (max-width: 413px) {
  .mainlogo {
    font-size: 2.5rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TkContacts.vue